import React, { useRef } from 'react';
import { useToggle } from 'react-use';
import styled from 'styled-components';
import { TaxBracket } from './RothConversionTypes';
import { formatPercentage } from '../../../CommonUtils/formatNumber';

const Wrapper = styled.div`
  position: relative;
`;

const Content = styled.ul`
  position: absolute;

  width: 100%;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin: 0;
  list-style-type: none;
  padding: 4px 0;

  li {
    padding: 4px 8px;

    &:hover {
      background: #cae9f5;
    }

    > * + * {
      margin-left: 4px;
      vertical-align: middle;
    }
  }
`;

export interface TaxBracketOption extends TaxBracket {
  selected: boolean;
}

interface Props {
  values: TaxBracketOption[];
  onChange: (values: TaxBracketOption[]) => void;
}

export const TaxBracketPopover: React.FC<Props> = ({ children, values, onChange }) => {
  const [visible, toggleVisible] = useToggle(false);
  const triggerRef = useRef<HTMLDivElement>(null);

  return (
    <Wrapper onMouseEnter={toggleVisible} onMouseLeave={toggleVisible}>
      <div ref={triggerRef}>{children}</div>
      {visible && (
        <Content style={{ top: `${triggerRef.current?.getBoundingClientRect().height || 0}px` }}>
          {values.map(({ value, selected, color }, i) => (
            <li key={value}>
              <input
                type="checkbox"
                checked={selected}
                onChange={ev =>
                  onChange([
                    ...values.slice(0, i),
                    { ...values[i], selected: ev.target.checked },
                    ...values.slice(i + 1),
                  ])
                }
              />
              <span style={{ color }}>&#9679;</span>
              <span>{formatPercentage(value)}</span>
            </li>
          ))}
        </Content>
      )}
    </Wrapper>
  );
};
